import './Contact.css'
import React from 'react'
import Helmet from 'react-helmet'


// import Form from '../components/FormSimpleAjax'
import Content from '../components/Content'

// Export Template for use in CMS preview
export const GetQuotePageTemplate = ({ title, image, contactTitle, contactContent }) => {

    return <main className="contact-page">
        <Helmet>
            <title>Assetlogue – Get a Quote</title>
        </Helmet>
        {image && <div className='banner-image' style={{ backgroundImage: `url(${image.publicURL})` }}></div>}
        <div className='container'>
            {title && <h1>{title}</h1>}

            <div className='contact-container'>
                <iframe src="https://pipedrivewebforms.com/form/0ea47b5e5ff7d4fcebda2f222cc9a6813343926"></iframe>
                {/* <Form
                    submitButton='SEND'
                    formName='Get a Quote'
                >
                    <div className='input-row'>
                        <label className="Form--Label">
                            <input
                                className="Form--Input"
                                type="text"
                                placeholder="What is your name?*"
                                name="name"
                                required
                            />
                        </label>
                        <label className="Form--Label">
                            <input
                                className="Form--Input"
                                type="text"
                                placeholder="What is your work e-mail address?*"
                                name="email"
                                required
                            />
                        </label>
                    </div>
                    <div className='input-row'>
                        <label className="Form--Label">
                            <input
                                className="Form--Input"
                                type="text"
                                placeholder="What is your phone number?*"
                                name="phone"
                                required
                            />
                        </label>
                        <label className="Form--Label">
                            <input
                                className="Form--Input"
                                type="text"
                                placeholder="What is your organisation's name?*"
                                name="organisation"
                                required
                            />
                        </label>
                    </div>
                    <div>
                        <p>Select your user Type *</p>
                        <div className='radio-container'>
                            <label>
                                <input type='radio' name='user_type' value='Contractor/Trades' />
                                <p>Contractor/Trades</p>
                            </label>
                            <label>
                                <input type='radio' name='user_type' value='Engineer' />
                                <p>Engineer</p>
                            </label>
                            <label>
                                <input type='radio' name='user_type' value='Local Authority' />
                                <p>Local Authority</p>
                            </label>
                            <label>
                                <input type='radio' name='user_type' value='Property Owner/Body Corp' />
                                <p>Property Owner/Body Corp</p>
                            </label>
                            <label>
                                <input type='radio' name='user_type' value='Property Developer' />
                                <p>Property Developer</p>
                            </label>
                            <label>
                                <input type='radio' name='user_type' value='Other' />
                                <p>Other</p>
                            </label>
                        </div>
                    </div>

                    <label className="Form--Label">
                        <p>How many Assets do you manage? How many Users would you like? Please include any other relevant information. *</p>
                        <textarea
                            className="Form--Input Form--Textarea"
                            name="message"
                            rows="10"
                            required
                        />
                    </label>
                </Form> */}

                <div>
                    {contactTitle && <h2>{contactTitle}</h2>}
                    {contactContent && <Content src={contactContent} />}
                </div>
            </div>

        </div>
    </main>
}

// Export Default HomePage for front-end
const GetQuotePage = ({ data: { page, settingsYaml } }) => (
    <GetQuotePageTemplate {...page} {...page.frontmatter} {...settingsYaml} body={page.html} />
)

export const pageQuery = graphql`
  ## Query for HomePage data
  ## Use GraphiQL interface (http://localhost:8000/___graphql)
  ## $id is processed via gatsby-node.js
  ## query name must be unique to this file
  query GetQuotePage($id: String!) {
    page: markdownRemark(id: { eq: $id }) {
      html
      frontmatter {
          title
          image {
              publicURL
          }
          contactTitle
          contactContent
      }
    }
    settingsYaml {
        trialBanner {
            buttonText
            buttonUrl
            subtitle
            title
        }
        testimonials {
            title
            testimonial {
                image
                name
                title
                content
            }
        }
        faqs {
            title
            faq {
                question
                answer
            }
        }
    }
  }
`


export default GetQuotePage




// WEBPACK FOOTER //
// ./src/templates/GetQuotePage.js